import { type ReactNode } from 'react';
import clsx from 'clsx';

export interface FieldGridProps {
  children: ReactNode;
  className?: string;
  /** Columns on desktop (>=768px). Default 2. */
  columns?: 1 | 2 | 3;
}

export function FieldGrid({ children, className, columns = 2 }: FieldGridProps) {
  const colClass =
    columns === 3
      ? 'md:grid-cols-3'
      : columns === 2
        ? 'md:grid-cols-2'
        : 'md:grid-cols-1';
  return (
    <div className={clsx('grid grid-cols-1 gap-5 md:gap-6', colClass, className)}>{children}</div>
  );
}
